import styled from 'styled-components';

export const GeoStyles = styled.div`
  vertical-align: bottom;
  margin-top: 8px;
  font-size: ${({ theme }) => theme.fontSize.sm};

  .text {
    margin-left: 4px;
  }
`;
